var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VTimepicker',_vm._g(_vm._b({staticClass:"time-input",class:{
        'time-input--block': _vm.block,
        'time-input--full': _vm.full,
    },attrs:{"auto-scroll":"","format":"HH:mm","hide-clear-button":"","lazy":""}},'VTimepicker',_vm.$attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }